import React, {useState, useEffect}  from 'react';
import { Col, Row, Button, FormGroup, Label, Input,Alert} from 'reactstrap';
import * as IoIcons from 'react-icons/io';
import Navbarh from '../navbar/Navbar';
//import ImageUploader from 'react-images-upload';       

 //Función principal 
function Esqueleto() {      
    const [formType, setFormType]=useState('Texto modificado');
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");    
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando]=useState(false);
    const onDismiss = () => setAVisible(false);

    //Método useEffect que sirve para ejecutar funciones al abrir módulo
    useEffect(() => {
      //Poner función a ejecutar. ejemplo;
      //fetchClientes();        
    }, []);

    function catalogo(){      
      setFormType("Catálogo");
    }
    function detalle(){      
      setFormType("Detalle");
    }
    
    //Diseño de la página
    return (
        <>     
        <Navbarh/>                    
        <row>
            <div className="headerp">                  
            <IoIcons.IoIosBook className="iconoc floatleft"  />                                                         
              <h3 >{formType }</h3>     
              <Button onClick={catalogo} color="secondary"> Enviar a catálogo</Button>
              <Button onClick={detalle} color="danger"> Enviar a detalle</Button>
            </div>            
        </row>   
        <div className="conteiner5">
          <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                {mensajeAlert}
            </Alert>
            {cargando===true &&(
              <Row>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " > 
                    <img  width= "150px" src="assets/img/preloader.gif"/> 
                </div>
              </Row>
            ) } 
           {//Catálogo 
                formType ==='Catálogo' &&(
                    <h5>Estás en el catálogo</h5>
            )}
            {//Detalle 
                formType ==='Detalle' &&(
                  <h5>Estás en el detalle</h5>
          )}
      
        
        </div>     
        </>
    )
}

export default Esqueleto
